import Container from "@/components/atoms/Container";
import TicketForm, {
  TicketProps,
  useTicketForm,
} from "@/components/organisms/Ticket/Form";
import ClientTicketForm, {
  ClientTicketProps,
  useClientTicketForm,
} from "@/components/organisms/Ticket/ClientForm";
import useMessageProps from "@/hooks/useMessageProps";
import Ticket from "@/types/Ticket";
import { router } from "@inertiajs/react";
import { useState } from "react";
import Button from "@/components/atoms/Button";
import Link from "@/components/atoms/Link";
import { Undo2 } from "lucide-react";
import { Account } from "@/types/Account";
import useAccess from "@/hooks/useAccess";

type Props = (TicketProps | ClientTicketProps) & {
  ticket: Ticket;
  redirect_props: any;
  accounts: Account[];
};

const NewTicket = ({ ticket, redirect_props, ...rest }: Props) => {
  const { currentUser, getAccess } = useAccess();
  const isClient = currentUser?.roles.some((role) => role.name === "client");

  const form = isClient ? useClientTicketForm(ticket) : useTicketForm(ticket);
  const [loading, setLoading] = useState(false);

  useMessageProps({ redirect_props });

  const onSubmit = (data: any) => {
    router.post(`/tickets`, data, {
      onStart: () => setLoading(true),
      onFinish: () => setLoading(false),
    });
  };

  return (
    <Container>
      <Container>
        <div className="flex flex-wrap justify-between gap-4">
          <div className="w-full md:w-auto"></div>
          <div className="flex flex-wrap gap-2">
            <Link href="/tickets">
              <Button className="flex items-center gap-2">
                <Undo2 size={16} /> Back
              </Button>
            </Link>
          </div>
        </div>
      </Container>

      {!isClient ? (
        <TicketForm
          form={form}
          edit={true}
          ticket={ticket}
          onSubmit={onSubmit}
          data={rest}
          loading={loading}
          mode="create"
          errors={redirect_props?.errors}
        />
      ) : (
        <ClientTicketForm
          form={form}
          edit={true}
          ticket={ticket}
          onSubmit={onSubmit}
          data={rest}
          loading={loading}
          mode="create"
          errors={redirect_props?.errors}
        />
      )}
    </Container>
  );
};

export default NewTicket;

